import share from "../images/sectwo/Sharin.svg";
import app from "../images/sectwo/NoApp.svg";
import link from "../images/sectwo/MyLink.svg";
import update from "../images/sectwo/update.svg";

export const fourProperties = [
  {
    pic: share,
    head: "Link Sharing",
    content: "Unlimitedly sharing",
  },
  {
    pic: app,
    head: "No Need App",
    content: "No installing any app & No memory consumption",
  },
  {
    pic: link,
    head: "Just Tap",
    content: "No need to remember url, just tap it",
  },
  {
    pic: update,
    head: "Update Your Info",
    content: "Edit your information anytime",
  }
]

// export const urlredirecting = "https://tapxtream.invtechnologies.in/profile"
export const urlredirecting = "https://tapxtream.com/profile"

// http://localhost:3000/profile
